// src/components/features/Navigacia/tour/sections/mojaUcebna.js
import { i18n } from "@/i18n";
import avatarCelebration from "@/assets/images/gallery/avatar-like.png";

const translate = (...args) => i18n.global.t(...args);

export function steps() {
  const waitShort = 520;
  const waitMedium = 640;
  const smoothScroll = {
    scrollMode: "nearest",
    scrollInline: "nearest",
    scrollBehavior: "smooth",
  };

  const t = translate;

  return [
    {
      goto: "/ucebna",
      selectors: [
        ".computer .column-center .time-stats-wrapper",
        ".mobile .stats .time-stats-wrapper",
      ],
      title: t("tour.sections.mojaUcebna.steps.timeStats.title"),
      text: t("tour.sections.mojaUcebna.steps.timeStats.text"),
      side: "left",
      pad: { x: 26, y: 20 },
      radius: 20,
      waitFor: waitMedium,
      ...smoothScroll,
    },
    {
      selectors: [
        ".computer .column-center .statistika-wrapper",
        ".mobile .stats .statistika-wrapper",
      ],
      title: t("tour.sections.mojaUcebna.steps.scoresStats.title"),
      text: t("tour.sections.mojaUcebna.steps.scoresStats.text"),
      side: "left",
      pad: { x: 24, y: 18 },
      radius: 18,
      waitFor: waitMedium,
      ...smoothScroll,
    },
    {
      selectors: [
        ".computer .column-left .friend-list",
        ".mobile .profile-actions .friend-list",
      ],
      title: t("tour.sections.mojaUcebna.steps.friends.title"),
      text: t("tour.sections.mojaUcebna.steps.friends.text"),
      side: "right",
      pad: { x: 26, y: 22 },
      radius: 22,
      waitFor: waitMedium,
      ...smoothScroll,
    },
    {
      selectors: [".computer .column-left .news-list", ".mobile .news-list"],
      title: t("tour.sections.mojaUcebna.steps.news.title"),
      text: t("tour.sections.mojaUcebna.steps.news.text"),
      side: "right",
      pad: { x: 22, y: 18 },
      radius: 18,
      waitFor: waitMedium,
      ...smoothScroll,
    },
    {
      selectors: [
        ".computer .column-center .naposledy-sledovane",
        ".mobile .naposledy-sledovane",
      ],
      title: t("tour.sections.mojaUcebna.steps.lastWatched.title"),
      text: t("tour.sections.mojaUcebna.steps.lastWatched.text"),
      side: "left",
      pad: { x: 24, y: 20 },
      radius: 20,
      waitFor: waitMedium,
      ...smoothScroll,
    },
    {
      selectors: ["[data-tour='task-seven-day']"],
      title: t("tour.sections.mojaUcebna.steps.sevenDay.title"),
      text: t("tour.sections.mojaUcebna.steps.sevenDay.text"),
      side: "left",
      pad: { x: 16, y: 12 },
      radius: 16,
      waitFor: waitShort,
      noScroll: true,
      ...smoothScroll,
    },
    {
      selectors: ["[data-tour='task-next']"],
      title: t("tour.sections.mojaUcebna.steps.nextTask.title"),
      text: t("tour.sections.mojaUcebna.steps.nextTask.text"),
      side: "left",
      pad: { x: 16, y: 12 },
      radius: 16,
      waitFor: waitShort,
      noScroll: true,
      ...smoothScroll,
    },
    {
      selectors: ["[data-tour='task-invite']"],
      title: t("tour.sections.mojaUcebna.steps.invite.title"),
      text: t("tour.sections.mojaUcebna.steps.invite.text"),
      side: "left",
      pad: { x: 16, y: 12 },
      radius: 16,
      waitFor: waitShort,
      noScroll: true,
      ...smoothScroll,
    },
    {
      selectors: [
        ".computer .column-right .box-item.oblubene",
        ".mobile .oblubene-zapisy .box-item.oblubene",
      ],
      title: t("tour.sections.mojaUcebna.steps.favorites.title"),
      text: t("tour.sections.mojaUcebna.steps.favorites.text"),
      side: "left",
      pad: { x: 26, y: 20 },
      radius: 20,
      waitFor: waitShort,
      ...smoothScroll,
    },
    {
      selectors: ["[data-tour='bottom-nav-vouchers']"],
      title: t("tour.sections.mojaUcebna.steps.bottomVouchers.title"),
      text: t("tour.sections.mojaUcebna.steps.bottomVouchers.text"),
      side: "top",
      pad: { x: 16, y: 10 },
      radius: 14,
      waitFor: waitShort,
      ...smoothScroll,
    },
    {
      selectors: ["[data-tour='bottom-nav-subscription']"],
      title: t("tour.sections.mojaUcebna.steps.bottomSubscription.title"),
      text: t("tour.sections.mojaUcebna.steps.bottomSubscription.text"),
      side: "top",
      pad: { x: 16, y: 10 },
      radius: 14,
      waitFor: waitShort,
      ...smoothScroll,
    },
    {
      selectors: ["[data-tour='bottom-nav-helicas']"],
      title: t("tour.sections.mojaUcebna.steps.bottomHelicas.title"),
      text: t("tour.sections.mojaUcebna.steps.bottomHelicas.text"),
      side: "top",
      pad: { x: 16, y: 10 },
      radius: 14,
      waitFor: waitShort,
      ...smoothScroll,
    },
    {
      selectors: ["[data-tour='bottom-nav-books']"],
      title: t("tour.sections.mojaUcebna.steps.bottomBooks.title"),
      text: t("tour.sections.mojaUcebna.steps.bottomBooks.text"),
      side: "top",
      pad: { x: 16, y: 10 },
      radius: 14,
      waitFor: waitShort,
      ...smoothScroll,
    },
    {
      selectors: ["[data-tour='bottom-nav-settings']"],
      title: t("tour.sections.mojaUcebna.steps.bottomSettings.title"),
      text: t("tour.sections.mojaUcebna.steps.bottomSettings.text"),
      side: "top",
      pad: { x: 14, y: 10 },
      radius: 14,
      waitFor: waitShort,
      ...smoothScroll,
    },
  ];
}

export function branch() {
  return {
    title: translate("tour.branches.mojaUcebna.title"),
    text: translate("tour.branches.mojaUcebna.text"),
    avatar: avatarCelebration,
    planBridgeLabel: translate("tour.branches.mojaUcebna.planBridgeLabel"),
    options: [
      {
        label: translate("tour.branches.mojaUcebna.options.finish.label"),
        planLabel: translate(
          "tour.branches.mojaUcebna.options.finish.planLabel"
        ),
        planBridgeLabel: translate(
          "tour.branches.mojaUcebna.options.finish.planBridgeLabel"
        ),
        steps: [],
      },
    ],
  };
}
